module.exports = __webpack_public_path__ + "img/right-arrow.b7163f09.svg";